
import { Load } from '../../types';
import { groundFloorLoads } from './groundFloor';
import { firstFloorLoads } from './firstFloor';
import { secondFloorLoads } from './secondFloor';

// Combine all loads from different floors
export const initialLoads: Load[] = [
  ...groundFloorLoads,
  ...firstFloorLoads,
  ...secondFloorLoads
];

// Helper function to get loads by floor
export const getLoadsByFloor = (floorId: number): Load[] => {
  switch (floorId) {
    case 1:
      return groundFloorLoads;
    case 2:
      return firstFloorLoads;
    case 3:
      return secondFloorLoads;
    default:
      return [];
  }
};

// Helper function to get a specific load by ID
export const getLoadById = (loadId: string): Load | undefined => {
  return initialLoads.find(load => load.id === loadId);
};

// Helper function to get loads by type
export const getLoadsByType = (type: string): Load[] => {
  return initialLoads.filter(load => load.type === type);
};
